var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useCallback } from 'react';
export var useTableSelection = function (page, onChange) {
    var _a = useState(false), checkTodos = _a[0], setCheckTodos = _a[1];
    var _b = useState(0), selecionados = _b[0], setSelecionados = _b[1];
    var handleSelectAllChange = useCallback(function () {
        var _a;
        var newSelectAll = !checkTodos;
        setCheckTodos(newSelectAll);
        var newRows = (_a = page === null || page === void 0 ? void 0 : page.content) === null || _a === void 0 ? void 0 : _a.map(function (row) { return (__assign(__assign({}, row), { checked: newSelectAll })); });
        onChange(__assign(__assign({}, page), { content: newRows }));
        setSelecionados(newSelectAll ? (page === null || page === void 0 ? void 0 : page.totalElements) || 0 : 0);
    }, [checkTodos, page, onChange]);
    var handleRowCheckboxChange = useCallback(function (id) {
        var _a;
        var newRows = (_a = page === null || page === void 0 ? void 0 : page.content) === null || _a === void 0 ? void 0 : _a.map(function (row) { return (__assign(__assign({}, row), { checked: row.id === id ? !row.checked : row.checked })); });
        var selectedCount = (newRows === null || newRows === void 0 ? void 0 : newRows.filter(function (row) { return row.checked; }).length) || 0;
        setCheckTodos(selectedCount === (page === null || page === void 0 ? void 0 : page.totalElements));
        setSelecionados(selectedCount);
        onChange(__assign(__assign({}, page), { content: newRows }));
    }, [page, onChange]);
    return { checkTodos: checkTodos, selecionados: selecionados, handleSelectAllChange: handleSelectAllChange, handleRowCheckboxChange: handleRowCheckboxChange };
};
